import type { ApolloClient } from "@apollo/client";
import type { Dispatch } from "redux";

import { portfolioConstants } from "./types";
import {
  getPortfolios,
  updateUserPortfolio,
  getActivePortfolio,
  getPositions,
  getPerformance,
  addRolloverAccountPortfolio,
} from "services/portfolioService";
import ActionCreator from "utils/actionHandler";

export const getAllPortfolios = (
  client: ApolloClient<object>,
  accountId?: string | null
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof getPortfolios>>
    >(portfolioConstants.GET_PORTFOLIOS);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      getPortfolios(client, accountId)
    );
  };
};

export const getUserPortfolio = (
  client: ApolloClient<object>,
  accountId?: string | null
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof getActivePortfolio>>
    >(portfolioConstants.GET_USER_PORTFOLIO);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      getActivePortfolio(client, accountId)
    );
  };
};

export const selectUserPortfolio = (
  client: ApolloClient<object>,
  params: Parameters<typeof updateUserPortfolio>[1]
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof updateUserPortfolio>>
    >(portfolioConstants.UPDATE_USER_PORTFOLIO);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      updateUserPortfolio(client, params)
    );
  };
};

export const getUserPositions = (
  client: ApolloClient<object>,
  accountId: string
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof getPositions>>
    >(portfolioConstants.GET_POSITIONS);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      getPositions(client, accountId)
    );
  };
};

export const getUserPerformance = (
  client: ApolloClient<object>,
  accountId: string,
  startTime: Parameters<typeof getPerformance>[2],
  endTime: Parameters<typeof getPerformance>[3]
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof getPerformance>>
    >(portfolioConstants.GET_PERFORMANCE);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      getPerformance(client, accountId, startTime, endTime)
    );
  };
};

export const rolloverAccountPortfolio = (
  client: ApolloClient<object>,
  portfolioId: string
) => {
  return (dispatch: Dispatch) => {
    const actionCreator = new ActionCreator<
      Awaited<ReturnType<typeof addRolloverAccountPortfolio>>
    >(portfolioConstants.SELECT_USER_ROLLOVER_PORTFOLIO);
    return actionCreator.dispatchFullLifecycle(
      dispatch,
      addRolloverAccountPortfolio(client, portfolioId)
    );
  };
};

export default {
  getAllPortfolios,
  getUserPositions,
  getUserPerformance,
  rolloverAccountPortfolio,
};
